import styled from 'styled-components';

export const Wrapper = styled.div<{ $isOpen: boolean }>`
  width: 100%;
  height: 100%;
  display: ${({ $isOpen }) => ($isOpen ? 'flex' : 'none')};
  flex-direction: column;
  align-items: flex-start;
  overflow-y: auto;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  max-width: 66.67%;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  padding: 16px 0 16px 20px;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  align-self: stretch;
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.colors.black4};
  font-weight: 600;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
  padding: 24px 20px;

  .ant-form-item {
    margin-bottom: 0 !important;
  }
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
  width: 100%;
`;

export const TitleText = styled.span`
  font-size: 14px;
  font-weight: 600;
`;

export const SubtitleText = styled.span`
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.black7};
`;

export const InputWrapper = styled.div`
  width: 100%;
  background: ${({ theme }) => theme.colors.white};
  border-radius: 4px;
  padding: 8px 0;
  border: 1px solid ${({ theme }) => theme.colors.black3};

  transition: all 0.2s ease-in-out;

  &:hover {
    border-color: ${({ theme }) => theme.colors.green6};
  }

  &:focus-within {
    border-color: ${({ theme }) => theme.colors.green6};
    box-shadow: 0px 0px 1px 2px ${({ theme }) => theme.colors.green2};
  }

  .ant-form-item {
    width: 100%;
  }
`;
